"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.freeze");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.object.values");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.bannerType = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/*
Let `bannerType` be a list of available colours the hero banner may be painted.
Let `type` be a string mapping to a colour the hero banner must be painted.
Let `type` only contain uppercase characters.
If `type` is present in `bannerType`.
	Paint hero banner using `type`.
Else apply default colour.
*/
var bannerType = Object.freeze({
  PURPLE: 'purple',
  GREY: 'grey'
});
exports.bannerType = bannerType;

var HeroBanner = /*#__PURE__*/function (_React$Component) {
  _inherits(HeroBanner, _React$Component);

  var _super = _createSuper(HeroBanner);

  function HeroBanner() {
    _classCallCheck(this, HeroBanner);

    return _super.apply(this, arguments);
  }

  _createClass(HeroBanner, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          type = _this$props.type,
          backgroundUrl = _this$props.backgroundUrl,
          heading = _this$props.heading,
          paragraph = _this$props.paragraph;
      var classes = (0, _classnames.default)(type, 'hero-banner__overlay');
      return /*#__PURE__*/_react.default.createElement("section", {
        className: "hero-banner ".concat(type, " ").concat(this.props.isCompact ? 'is-compact' : ''),
        style: {
          backgroundImage: "url(".concat(backgroundUrl, ")")
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: classes
      }), (heading || paragraph || children) && /*#__PURE__*/_react.default.createElement("div", {
        className: "l-padding"
      }, heading && /*#__PURE__*/_react.default.createElement("h1", {
        className: "hero-banner__heading",
        tabIndex: "-1"
      }, heading), paragraph && /*#__PURE__*/_react.default.createElement("p", {
        className: "hero-banner__paragraph introduction"
      }, paragraph), children));
    }
  }], [{
    key: "Type",
    get: function get() {
      return bannerType;
    }
  }]);

  return HeroBanner;
}(_react.default.Component);

HeroBanner.defaultProps = {
  type: bannerType.PURPLE,
  children: null,
  backgroundUrl: null,
  heading: null,
  paragraph: null,
  isCompact: false
};
HeroBanner.propTypes = {
  type: _propTypes.default.oneOf(Object.values(bannerType)).isRequired,
  heading: _propTypes.default.string,
  paragraph: _propTypes.default.string,
  backgroundUrl: _propTypes.default.string,
  children: _propTypes.default.node,
  isCompact: _propTypes.default.bool
};
var _default = HeroBanner;
exports.default = _default;
//# sourceMappingURL=HeroBanner.js.map